import './index.less';

const { Feature, meta, hook, event } = checkApp.core; //eslint-disable-line
const { Button, Tooltip, Loading } = checkApp.components;//eslint-disable-line

const knowledgeData = window._knowledge || [
  {
    text: '如何选择适合您的域名？',
    link: 'http://help.www.net.cn/knowledge_detail.htm?knowledgeId=5867729'
  },
  {
    text: '如何购买域名？',
    link: 'http://help.www.net.cn/knowledge_detail.htm?knowledgeId=5853982'
  },
  {
    text: '什么是白金域名？',
    link: 'https://help.aliyun.com/knowledge_detail/60597.html'
  },
  {
    text: '.cn等国内域名如何提交资料审核？',
    link: 'http://help.www.net.cn/knowledge_detail.htm?knowledgeId=5867902'
  },
  {
    text: '域名要备案吗，如何备案？',
    link: 'http://wanwang.aliyun.com/promotion/20130043/'
  },
  {
    text: '从域名到网站，要做哪几步？',
    link: 'http://help.www.net.cn/knowledge_detail.htm?knowledgeId=5867827'
  }
];

@meta('knowledge', ['request'], -7)
export default class KnowledgeFeature extends Feature {

  /**
   * 渲染右侧面板
   * @param {object} state 状态对象
   * @returns {objecg} 面板 dom
   */
  @hook('main.renderSidePanel')
  renderSidePanel() {
    return <div key={this.id} className="panel side knowledge-panel">
      <div className="knowledge-wrapper">
        <p className="title">域名小知识</p>
        <div className="knowledges-container">
          <ul>
            {knowledgeData.map((item, index) => {
              return <li key={index}>
                <a href={item.link || item.value} target="_blank">&middot;
                  <span>{item.text}</span>
                </a>
              </li>;
            })}
          </ul>
        </div>
      </div>
    </div>;
  }

}


// WEBPACK FOOTER //
// ./src/knowledge/index.js